import { useSearchParams } from 'react-router-dom';

import { ChatWidget } from '../flow/ChatWidget';
import { FlowRunner } from '../flow/FlowRunner';
import { EmptySession } from '../ui/EmptySession';

/**
 * Explicit verification entry. The case-bound applicant token arrives as
 * `?token=<uuid>`; with it, the FlowRunner renders the current step straight
 * from the backend collection-flow JSON. Without a token, show a soft empty
 * state (not a red failure glyph).
 */
export function VerifyScreen() {
  const [params] = useSearchParams();
  const token = params.get('token')?.trim() || null;

  if (!token) {
    return <EmptySession kind="missing" />;
  }

  // Desktop entry: open the session and offer the QR handoff to a phone.
  return (
    <>
      <FlowRunner token={token} withHandoff />
      <ChatWidget token={token} />
    </>
  );
}
